$(document).ready(function() {
  // console.log('checkbox_toggle_fields.js loaded');

  // Khi trang load
  initToggleCheckboxes();

  // Khi ActiveAdmin reload form (PJAX load lại)
  $(document).on('ajax:complete', function() {
    initToggleCheckboxes();
  });

  // Khi checkbox thay đổi
  $(document).on('change', '.js-toggle-checkbox', function() {
    toggleTarget($(this));
  });
});

function initToggleCheckboxes() {
  $('.js-toggle-checkbox').each(function() {
    toggleTarget($(this));
  });
}

function toggleTarget($checkbox) {
  const targetSelector = $checkbox.data('target');
  const $target = $(targetSelector);

  if ($target.length === 0) return;

  // Nếu check thì hiện, không check thì ẩn
  $target.toggleClass('none', !$checkbox.is(':checked'));
}

// $(document).on('turbo:load ready', function() {
//   console.log('checkbox_toggle_fields.js loaded');
//   // Cập nhật trạng thái khi load trang
//   $('.js-toggle-checkbox').each(function() {
//     const targetSelector = $(this).data('target');
//     const $target = $(targetSelector);
//     if ($target.length === 0) return;

//     if ($(this).is(':checked')) {
//       $target.removeClass('none');
//     } else {
//       $target.addClass('none');
//     }
//   });

//   // Xử lý khi checkbox thay đổi
//   $(document).on('change', '.js-toggle-checkbox', function() {
//     const targetSelector = $(this).data('target');
//     const $target = $(targetSelector);
//     if ($target.length === 0) return;

//     $target.toggleClass('none', !$(this).is(':checked'));
//   });
// });
